<script>
  import LiveReporting from 'src/pc/pages/LiveReporting'
  import PageLayout from '../layouts/PageLayout'
  import SubPageLayout from '../layouts/SubPageLayout'
  import DisplayContainer from '../components/DisplayContainer'
  import ReportInfo from '../components/ReportInfo'
  export default {
    extends: LiveReporting,
    data () {
      return {
        isHidden: true
      }
    },
    components: {
      SubPageLayout,
      PageLayout,
      DisplayContainer,
      ReportInfo
    },
    computed: {
      getAccess() {
        return 'mobile'
      }
    }
  }
</script>

<style>
  .live_reporting .event_subj {
    max-width: 100vw;
    margin: 20px 20px 0;
  }
  .live_reporting .event_subj .subj {
    font-size: 22px;
    margin: 10px 0 30px;
  }
  .live_reporting .event_subj i {
    font-size: 14px;
    margin-right: 6px;
  }
  .live_reporting .event_subj .tabs.menu {
    margin-top: 5px;
  }
  .live_reporting .event_subj .tabs.menu ul li {
    font-size: 16px;
    line-height: 1.2em;
    margin: 0 1.0vw;
    letter-spacing: -0.02em;
    width: calc(25% - 1.5vw);
    text-align: center;
    vertical-align: bottom;
  }
  .live_reporting .event_subj .tabs.menu ul li:first-child {
    margin-left: 0;
  }
  .live_reporting .event_subj .tabs.menu ul li:last-child {
    margin-right: 0;
  }
  .live_reporting .tabs.days {
    padding: 20px 0;
    width: calc(100vw - 40px);
  }
  .live_reporting .tabs.days ul {
    width: calc(100% - 80px);
    overflow-x: auto;
    overflow-y: hidden;
    white-space: nowrap;
    position: relative;
  }
  .live_reporting .tabs.days ul:after {
    content: "";
    display: inline-block;
    width: 50px;
    height: 30px;
    background: linear-gradient(to right, rgba(0,0,0,0), rgba(245,245,245,1.0));
    position: sticky;
    right: 0;
  }
  .live_reporting .tabs.days ul li {
    font-size: 13px;
    margin: 0;
    padding: 9px 16px;
  }
  .live_reporting .tabs.days .sort {
    padding: 7px 12px 7px 34px;
    font-size: 12px;
    font-weight: 600;
  }
  .live_reporting .tabs.days .sort:before {
    width: 12px;
    height: 12px;
  }
  .live_reporting .con_wrapper {
    width: 100%;
    padding-bottom: 50px;
  }
  .live_reporting .report .subj {
    font-size: 22px;
    font-weight: 800;
    letter-spacing: -0.035em;
  }
  .live_reporting .report .date_area {
    font-size: 12px;
    line-height: 1.6em;
  }
  .live_reporting .report .date_area .date:after {
    content: "";
  }
  .live_reporting .report .date_area .level {
    display: block;
  }
  .live_reporting .report .detail_con {
    font-size: 16px;
    font-weight: 300;
    line-height: 1.8em;
  }
  .live_reporting .detail_con table {
    width: calc(100vw - 40px) !important;
    white-space: nowrap;
    overflow-x: scroll;
    display: block;
  }
  .live_reporting .detail_con table tbody {
    display: table;
    width: 100%;
  }
  .live_reporting .detail_con table td {
    padding: 8px 2.0vw;
    font-size: 0.80em;
  }
  .live_reporting .detail_con table td:first-child {
    padding-left: 4vw;
  }
  .live_reporting .detail_con table td:last-child {
    padding-right: 4vw;
  }
  .live_reporting .detail_con table .flag {
    width: 20px;
  }
  .live_reporting .detail_con p.box {
    padding: 15px 20px;
  }
</style>
